module.exports = __webpack_public_path__ + "img/detail3.dc15c376.png";